import React, { useState } from "react";
import img from "../../assets/img/cat/Rectangle 88.png";
import Button from "../shared/Button";
import share from "../../assets/img/icons/share.svg";
import useFetch from "../../hooks/useAxios";
import ShareComponents from "./ShareComponents";
const BigCard = ({info}) => {
 console.log(info)
  return (
    <div className="Bigcard">
      <div className="flex  Bigcard-con justify-between">
        <div>
          <h2>{info.title}</h2>
          <p>
           {
             info.body
           }
          </p>
        </div>
       <img src={info.thumbnail.path} /> 
      </div>

      <div className="flex justify-between items-center Bigcard-foot ">
        {/* <ul className="Bigcard-ul">
          <li>دسته بندی ها</li>
          <li> ویلا و باغ </li>
          <li>استخر دارد</li>
        </ul> */}
        <div>

        </div>
       <Button varient="primary">
           <div className="flex">
           <img src={share} className='ml-[12px]' />
               <p>اشتراک گذاری با دوستان</p>
            
           </div>
       </Button>
       {/* <ShareComponents/> */}
      </div>
    </div>
  );
};

export default BigCard;
